import Vue from "vue";
import VueRouter from "vue-router";
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

Vue.use(VueRouter);

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue"),
    meta: {
      title: "Home",
      requiresAuth: false,
    },
  },
  {
    path: "/prayers",
    name: "Blogs",
    component: () => import(/* webpackChunkName: "blogs" */ "../views/Blogs.vue"),
    meta: {
      title: "Prayers",
      requiresAuth: false,
    },
  },
  {
    path: "/",
    name: "My_Rosary",
    beforeEnter() {window.location.href = 'https://myrosary-4c3ae.web.app/'},
    meta: {
      title: "MyRosary",
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import(/* webpackChunkName: "login" */ "../views/Login.vue"),
    meta: {
      title: "Login",
      requiresAuth: false,
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import(/* webpackChunkName: "register" */ "../views/Register.vue"),
    meta: {
      title: "Register",
      requiresAuth: false,
    },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import(/* webpackChunkName: "forgot-password" */ "../views/ForgotPassword.vue"),
    meta: {
      title: "Forgot Password",
      requiresAuth: false,
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import(/* webpackChunkName: "profile" */ "../views/Profile.vue"),
    meta: {
      title: "Profile",
      requiresAuth: true,
    },
  },
  {
    path: "/create-post",
    name: "CreatePost",
    component: () => import(/* webpackChunkName: "create-post" */ "../views/CreatePost.vue"),
    meta: {
      title: "Create Prayer",
      requiresAuth: true,
      requiresUser: true,
    },
  },
  {
    path: "/post-preview",
    name: "BlogPreview",
    component: () => import(/* webpackChunkName: "post-preview" */ "../views/BlogPreview.vue"),
    meta: {
      title: "Prayer Preview",
      requiresAuth: true,
      
    },
  },
  {
    path: "/view-prayer/:blogid",
    name: "ViewBlog",
    component: () => import(/* webpackChunkName: "view-blog" */ "../views/ViewBlog.vue"),
    meta: {
      title: "View Prayer",
      requiresAuth: false,
    },
  },
  {
    path: "/edit-blog/:blogid",
    name: "EditBlog",
    component: () => import(/* webpackChunkName: "edit-blog" */ "../views/EditBlog.vue"),
    meta: {
      title: "Edit Prayer",
      requiresAuth: true,
    },
  },
  {
    path: "/policy",
    name: "Policy",
    component: () => import(/* webpackChunkName: "policy" */ "../views/Policy.vue"),
    meta: {
      title: "Policy",
      requiresAuth: false,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} | The Roarians`;
  next();
});

router.beforeEach(async (to, from, next) => {
  let user = firebase.auth().currentUser;
  
  if (to.matched.some((res) => res.meta.requiresAuth)) {
    if (user) {
      if (to.matched.some((res) => res.meta.requiresUser)) {
        if (user) {
          return next();
        }
        return next({ name: "Home" });
      }
      return next();
    }
    return next({ name: "Home" });
  }
  return next();
});

export default router;